import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';

const usePackageQuantity = (packageTypes, mapper)=>{
    const { currency , getLabel , hasLabel  } = useIntl();
    const labels = React.useMemo(()=>({
            lenses: getLabel('products.unit.contactLenses'),
            lens: getLabel('products.unit.contactLens'),
            box: getLabel('products.unit.contactLensBox'),
            boxes: getLabel('products.unit.contactLensBoxes'),
            perEye: hasLabel('products.perEye') ? getLabel('products.perEye') : '',
            perBoxLabel: getLabel('products.perBox'),
            perMonth: getLabel('common.frequency.perMonth')
        })
    , [
        getLabel,
        hasLabel
    ]);
    const packageQuantities = React.useMemo(()=>{
        return packageTypes.map((pack)=>mapper(pack, labels, currency)
        );
    }, [
        packageTypes,
        mapper,
        labels,
        currency
    ]);
    return {
        labels,
        packageQuantities
    };
};

export { usePackageQuantity };
//# sourceMappingURL=usePackageQuantity.js.map
